import { httpClient } from '@/api/httpClient';
import {
  mapPaginatedResource,
  type PaginatedApiResource,
  type PaginatedResult,
} from '@/api/pagination.types';
import {
  buildInsightsQueryParameters,
  mapApiResourceToInsightsSummary,
  mapApiResourceToInsightsWorkspace,
} from './assistantInsightsMapping';
import type {
  AssistantInsightsFilters,
  InsightsSummary,
  InsightsSummaryApiResource,
  InsightsWorkspace,
  InsightsWorkspaceApiResource,
} from './assistantInsightsApi.types';

const INSIGHTS_BASE_PATH = '/assistant/insights';

export async function fetchAssistantInsightsSummary(
  filters: AssistantInsightsFilters
): Promise<InsightsSummary> {
  const response = await httpClient.get<InsightsSummaryApiResource>(
    INSIGHTS_BASE_PATH + '/summary',
    { params: buildInsightsQueryParameters(filters) }
  );
  return mapApiResourceToInsightsSummary(response.data);
}

export async function fetchAssistantInsightsWorkspaces(
  filters: AssistantInsightsFilters,
  page: number,
  pageSize: number,
  search: string
): Promise<PaginatedResult<InsightsWorkspace>> {
  const params: Record<string, unknown> = {
    ...buildInsightsQueryParameters(filters),
    page,
    page_size: pageSize,
  };
  const trimmedSearch = search.trim();
  if (trimmedSearch.length > 0) {
    params.search = trimmedSearch;
  }
  const response = await httpClient.get<PaginatedApiResource<InsightsWorkspaceApiResource>>(
    INSIGHTS_BASE_PATH + '/workspaces',
    { params }
  );
  return mapPaginatedResource(response.data, mapApiResourceToInsightsWorkspace);
}
